<script setup>
import { onMounted, ref } from 'vue'
import useIsotope from '@/Shared/useIsotope.js'
import Banners, { BANNERS } from '@/Shared/Sidebar/Banners.vue'
import Sidebar from './Sidebar.vue'

const containerRef = ref()

const isotope = (data) => {
  useIsotope({
    isotopeContainer: containerRef.value,
    isotopeItem: '.isotope-item',
    data: data,
    key: 'newsThumb',
  })
}

onMounted(() => {
  isotope(BANNERS)
})

</script>

<template>
  <Sidebar>
    <ul ref="containerRef" class="isotope-container pb-[50px] md:pb-[10px]">
      <Banners />
    </ul>
  </Sidebar>
</template>
